import { useFormatDate } from './use-format-date';

export function useFormatDates(from?: Date, to?: Date, region = 'en-au'): string {
    const formattedFrom = useFormatDate(from, region);
    const formattedTo = useFormatDate(to, region);
    return `${formattedFrom} - ${formattedTo}`;
}
